import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StorageService } from '../../../../services/storage.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../interfaces/app-state.interface';
import { TrackingActions } from '../../../../state-management/tracking/tracking.action';


@Component({
  selector: 'floating-chat',
  templateUrl: './floating-chat.component.html',
  styleUrls: ['./floating-chat.component.scss'],
})
export class FloatingChatComponent {
    public chatOnboardingCookie = StorageService.getCookie('chat-onboarding-welcome');
    @Input() statusChat: BehaviorSubject<boolean>;
    public checklistStatus = new BehaviorSubject(this.chatOnboardingCookie);

    public closeChat() {
        this.sendTracking('Element Clicked', {
            'Element': 'Botão fechar onboarding',
            'Group': 'Onboarding Trader',
            'Scenario': 'Início onboarding',
            'Time Responsável': 'Brooklyn Dumbo',
        })
        StorageService.setCookie('chat-onboarding-closed-preference', 'true');
        this.statusChat.next(false);
    }

    public sendTracking(event: string, breakdowns: any) {
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: { type: event, events: breakdowns },
        });
    };

    constructor(
        private store: Store<AppState>,
    ) { }
}
